@if (chart) {
  <div class="analyst-chart">
    @if (chart.title) {
      <div class="analyst-title">{{ chart.title }}</div>
    }
    @if (hasPoints) {
      <div class="chart-host" #chartDiv [style.height.px]="hostHeight"></div>
    }
    @if (!hasPoints) {
      <div class="chart-empty">{{ 'No chart data available' | translate }}</div>
    }
    @if (hasPoints) {
      <ul class="series-list">
        @for (seriesLabel of seriesLabels; track trackByIndex(seriesIndex); let seriesIndex = $index) {
          <li>
            {{ seriesLabel }}
            @if (seriesMarkers[seriesIndex]?.length) {
              <sup class="citation-markers">
                @for (marker of visibleSeriesMarkers[seriesIndex]; track trackByIndex($index)) {
                  <a [href]="marker.citation.route" (click)="onMarkerClick($event, marker.citation)">[{{ marker.index }}]</a>
                }
              </sup>
              @if (hiddenSeriesMarkers[seriesIndex]?.length) {
                <app-citation-overflow [markers]="hiddenSeriesMarkers[seriesIndex]"></app-citation-overflow>
              }
            }
          </li>
        }
      </ul>
    }
    @if (chart.truncated) {
      <div class="truncation-notice">
        {{ 'Showing {{shown}} of {{total}} data points' | translate: { shown: renderedPointCount, total: chart.totalPointCount } }}
      </div>
    }
  </div>
}
